import {
    CALENDAR_SETTINGS_ROUTE,
    CALENDAR_REGISTRATION_SETTINGS_ROUTE,
    CALENDAR_APPEARANCES_LIST_ROUTE
} from './constants';
import http from '../../../utils/httpService';

/**
 *
 * @param calendarID
 * @param object
 */
const requestUpdateCalendarSettings = ( calendarID, object ) => {
    const route = CALENDAR_SETTINGS_ROUTE + `/${ calendarID }`;
    return http.request( route, 'PUT', object );
};
/**
 *
 * @param settingsID
 * @param object
 */
const requestUpdateCalendarRegistrationSettings = ( settingsID, object ) => {
    const route = CALENDAR_REGISTRATION_SETTINGS_ROUTE + `/${ settingsID }`;
    return http.request( route, 'PUT', object );
};
/**
 *
 * @param calendarID
 */
const requestAppearancesList = calendarID => {
    const route = CALENDAR_APPEARANCES_LIST_ROUTE + `/${ calendarID }`;
    return http.request( route, 'GET' );
};

/**
 *
 * @param settingsID
 */
const requestCalendarSettings = settingsID => {
    const route = CALENDAR_SETTINGS_ROUTE + `/${ settingsID }`;
    return http.request( route, 'GET' );
};

export {
    requestUpdateCalendarSettings,
    requestUpdateCalendarRegistrationSettings,
    requestAppearancesList,
    requestCalendarSettings
};